export const getUrlParams = (url?: string) => {
  const { location } = global || {}
  const { href: currentHref } = location || {}
  const [, queryString] = /\?(.*?(?=#|$))/.exec(url || currentHref) || []
  if (!queryString) return {}
  const paramsList = queryString.split('&')

  return paramsList.reduce((acc, params) => {
    const keyValPairArray = params.split('=')
    const key = keyValPairArray[0]
    const value = keyValPairArray[1] && decodeURIComponent(keyValPairArray[1])
    acc[key] = value
    return acc
  }, {} as { [key: string]: string })
}
